/* Space Blue scroll-reveal: fade + rise section content on entry, one group at
   a time. CSS (critical.css) keeps .sb-reveal fully visible when the user
   prefers reduced motion, so this only enhances — it is never required. */
(function () {
  var els = document.querySelectorAll('.sb-reveal:not(.is-visible)');

  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  els.forEach(function (el) {
    observer.observe(el);
  });
})();
